const UNKNOWN = 'unknown'

const getDeviceTypeFromUserAgent = (userAgent = '') => {
  const ua = userAgent.toLowerCase()

  if (/ipad|tablet|playbook|silk|(android(?!.*mobile))/i.test(ua)) return 'tablet'
  if (/mobi|iphone|ipod|android|blackberry|iemobile|opera mini|windows phone/i.test(ua)) return 'mobile'
  if (/smart-tv|smarttv|hbbtv|appletv|googletv|tv/i.test(ua)) return 'tv'

  return 'desktop'
}

const getBrowserInfo = (userAgent = '') => {
  const browserMatchers = [
    { name: 'Edge', regex: /(edg|edge|edgios|edga)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Opera', regex: /(opr|opera)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Samsung Internet', regex: /(samsungbrowser)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Brave', regex: /(brave)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Chrome', regex: /(chrome|crios)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Firefox', regex: /(firefox|fxios)\/([\d.]+)/i, versionGroup: 2 },
    { name: 'Safari', regex: /version\/([\d.]+).*safari/i, versionGroup: 1 },
    { name: 'Internet Explorer', regex: /(msie)\s([\d.]+)/i, versionGroup: 2 },
    { name: 'Internet Explorer', regex: /(trident).*rv:([\d.]+)/i, versionGroup: 2 },
  ]

  for (const matcher of browserMatchers) {
    const match = userAgent.match(matcher.regex)
    if (match) {
      return {
        name: matcher.name,
        version: match[matcher.versionGroup] || UNKNOWN,
      }
    }
  }

  return { name: UNKNOWN, version: UNKNOWN }
}

const getOsInfo = (userAgent = '') => {
  const osMatchers = [
    { name: 'Windows', regex: /Windows NT ([\d.]+)/i, formatter: (v) => v },
    { name: 'iOS', regex: /OS (\d+[_\d]*) like Mac OS X/i, formatter: (v) => v.replace(/_/g, '.') },
    { name: 'Android', regex: /Android ([\d.]+)/i, formatter: (v) => v },
    { name: 'macOS', regex: /Mac OS X ([\d_]+)/i, formatter: (v) => v.replace(/_/g, '.') },
    { name: 'Linux', regex: /Linux/i, formatter: () => UNKNOWN },
    { name: 'Chrome OS', regex: /CrOS [\w]+ ([\d.]+)/i, formatter: (v) => v },
  ]

  for (const matcher of osMatchers) {
    const match = userAgent.match(matcher.regex)
    if (match) {
      return {
        name: matcher.name,
        version: matcher.formatter(match[1]),
      }
    }
  }

  return { name: UNKNOWN, version: UNKNOWN }
}

const getEngineInfo = (userAgent = '') => {
  const engineMatchers = [
    { name: 'Blink', regex: /chrome|chromium|edg|opr|brave/i },
    { name: 'WebKit', regex: /applewebkit/i },
    { name: 'Gecko', regex: /gecko\/\d/i },
    { name: 'Trident', regex: /trident/i },
  ]

  for (const matcher of engineMatchers) {
    if (matcher.regex.test(userAgent)) return { name: matcher.name }
  }

  return { name: UNKNOWN }
}

const getInfoDevice = () => {
  if (typeof navigator === 'undefined') {
    return {
      type: UNKNOWN,
      userAgent: UNKNOWN,
      browser: { name: UNKNOWN, version: UNKNOWN },
      engine: { name: UNKNOWN },
      os: { name: UNKNOWN, version: UNKNOWN },
    }
  }

  const userAgent = navigator.userAgent || UNKNOWN

  return {
    type: getDeviceTypeFromUserAgent(userAgent),
    userAgent,
    browser: getBrowserInfo(userAgent),
    engine: getEngineInfo(userAgent),
    os: getOsInfo(userAgent),
  }
}

export default getInfoDevice
